import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Modal, Checkbox } from 'semantic-ui-react'
import { Button } from '@120wateraudit/envirio-components'

import useAccount from 'hooks/useAccount'

export interface Props {
  open: boolean
  setOpen: (open: boolean) => void
}

export const DisclaimerModal = ({ open, setOpen }: Props): JSX.Element => {
  const { accountName } = useAccount()
  const disclaimerAgreement =
    localStorage.getItem('agreement') === 'true' ? true : false
  const [agreement, setAgreement] = useState<boolean>(disclaimerAgreement)

  useEffect(() => {
    if (!disclaimerAgreement) {
      setOpen(true)
    }
  }, [disclaimerAgreement])

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}>
      <Modal.Header>Disclaimer</Modal.Header>
      <Modal.Content>
        <Text>
          {` The information provided by 120Water and ${accountName}
                    shall be used for the purpose of providing property owners and
                    residents information regarding their water services. The data is not for commercial, legal, or other use.`}
        </Text>
        <Text>{`120Water and ${accountName} cannot guarantee the accuracy of these maps and is not liable
                for damages of any kind, including but not limited to lost business,
                lost profits, business interruption, data loss, or other loss that might arise
                from using this mapping resource and information. 120Water and ${accountName}
                reserves the right to update or terminate the display of these maps and records at any time.`}</Text>
        <div style={{ textAlign: 'left' }}>
          <Checkbox
            onClick={() => {
              setAgreement(!agreement)
              localStorage.setItem('agreement', JSON.stringify(!agreement))
            }}
            label="Do not show this screen again."
            style={{ fontSize: '1.2rem' }}
          />
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button size="med" onClick={() => setOpen(false)}>
            Okay
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  )
}

const Text = styled.p`
  font-size: 1.2rem;
`

export default DisclaimerModal
